import styled from 'styled-components';
import { colors } from '../../../../healtheraComponents';

export const StyledImageContainer = styled.div`
  margin-top: 10px;

  flex-direction: column;
  flex-shrink: 0;

  width: 170px;
  display: flex;
`;

export const StyledImageHeader = styled.p`
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledImageTitle = styled.span`
  color: ${colors.GRAY};
`;

export const StyledImageHolderContainer = styled.div`
  position: relative;
`;

export const StyledImageOverlay = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 106px;
  background-color: rgba(0, 0, 0, 0.5);

  display: none;

  &:hover {
    display: flex;
  }
`;

export const StyledImageHolder = styled.p<{ backgroundImage: string }>`
  border-radius: 5px;
  margin: 0;
  margin-top: 10px;
  background-image: url(${(props) => props.backgroundImage});
  backgroud-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  width: 100%;
  height: 106px;

  &:hover + ${StyledImageOverlay} {
    display: flex;
  }
`;

export const StyledErrorText = styled.p`
  margin: 0;
  margin-top: 5px;
  color: ${colors.HEALTHERA_RED};
  font-size: 14px;
`;
